module.exports = __webpack_public_path__ + "static/TowerGothic-6a981064a519c12033b32753498340df.otf";